import { createGtm, useGtm } from '@gtm-support/vue-gtm'

function isSlugAuthPath(path) {
  return /(?:^|\/)accounts\/login\//i.test(path)
}

export default ({ app, router }) => {
  if (process.env.GTM) {
    const waitForAuthRedirect = isSlugAuthPath(window.location.pathname)

    app.use(
      createGtm({
        id: process.env.GTM,
        compatibility: true,
        defer: true,
        enabled: !waitForAuthRedirect,
        debug: false,
        loadScript: true,
        vueRouter: router,
        ignoredViews: (to) => isSlugAuthPath(to.path),
        trackOnNextTick: true,
      }),
    )

    if (waitForAuthRedirect) {
      const removeAfterEach = router.afterEach((to, from, failure) => {
        if (failure || isSlugAuthPath(to.path) || isSlugAuthPath(window.location.pathname)) {
          return
        }

        useGtm()?.enable(true)
        removeAfterEach()
      })
    }
  }
}
